"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class ManualCard extends React.Component {
    constructor() {
        super(...arguments);
        this.createMarkup = () => {
            return { __html: this.props.content };
        };
    }
    render() {
        const { image, title, content } = this.props;
        return (React.createElement("div", { className: "column is-lg-3 is-md-4 is-xs-12", style: { height: '100%' } },
            image &&
                React.createElement("div", { className: "manual-card-image" },
                    React.createElement("img", { src: image })),
            React.createElement("div", { className: "manual-card-info" },
                title && (React.createElement("h2", { className: `card-title` }, title)),
                content && (React.createElement("div", { dangerouslySetInnerHTML: this.createMarkup() })))));
    }
}
exports.ManualCard = ManualCard;
exports.default = ManualCard;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-manual-card-list/ManualCard.tsx